import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'

import {
  ConversationActionType,
  useConversationActions,
} from '../../model/use-conversation-actions'
import type { ActionTarget } from '../../model/use-conversation-actions'

/**
 * Replaces the composer for a blocked counterparty — you can't message a blocked
 * number, only unblock it. Unblocking refetches the thread, which restores the
 * composer.
 */
export function UnblockBar({ target }: { target: ActionTarget }) {
  const { t } = useTranslation()
  const { apply, isPending } = useConversationActions()
  return (
    <div className="shrink-0">
      <div className="h-px w-full bg-warm-100" />
      <div className="flex flex-col items-center gap-2 px-4 py-4 text-center">
        <span className="text-xs text-warm-500">
          {t('phonePanel.conversation.blockedNotice')}
        </span>
        <Button
          variant="soft-destructive"
          size="sm"
          // `.phone-unblock-btn` carries the dark/midnight tint (see index.css)
          // so it flips with the app theme instead of on a React re-render.
          className="phone-unblock-btn w-full transition-all duration-200 active:scale-95"
          disabled={isPending}
          onClick={() => void apply(ConversationActionType.unblock, target)}
        >
          {t('phonePanel.conversation.unblock')}
        </Button>
      </div>
    </div>
  )
}
